<template>
  <div id="teacher_list">
    <div class="bottombox">
      <Header ref="header" />

    </div>
    <!-- 头部焦点图 -->
    <!-- <banner v-bind:pageTypeId="pageTypeId"></banner> -->
    <!-- banner end -->
    <!-- <div class="screen">
      <div class="clearfix screen_1">
        <strong>·FILTERS</strong>
        <span class="icon_open" @click="iconOpen" v-if="screenup">展开</span>
        <span class="icon_shrink" @click="iconShrink" v-else>收起</span>
      </div>
      <div class="clearfix screen_2" :class="{ up: screenup }">
        <p>
          <strong>课程分类：</strong>
          <span>
            <a :class="{ side: kcflNumber == 0 }" @click="kcflFun(0)">不限</a>
            <a
              :class="{ side: kcflNumber == index + 1 }"
              @click="kcflFun(index + 1)"
              v-for="(item, index) in enumList"
              >{{ item.Name }}</a
            >
          </span>
        </p>
        <p v-if="CourseC1">
          <strong>科目分类：</strong>
          <span>
            <a :class="{ side: kmNum == 0 }" @click="subjectsFun(0)">不限</a>
            <a
              :class="{ side: kmNum == index + 1 }"
              @click="subjectsFun(index + 1)"
              v-for="(item, index) in kmList"
              >{{ item }}</a
            >
          </span>
        </p>
        <p>
          <strong>线下分校：</strong>
          <span>
            <a :class="{ side: cityNumber == 0 }" @click="fxFunction(0)"
              >不限</a
            >
            <a
              :class="{ side: cityNumber == index + 1 }"
              v-for="(item, index) in fxList"
              @click="fxFunction(index + 1)"
              >{{ item.Name }}</a
            >
          </span>
        </p>
      </div>
      <div class="clearfix screen_S">
        <input
          type="text"
          placeholder="输入姓名以搜索教师"
          v-model="searchValue"
          @keyup.enter="searchEnter"
          @focus="searchfocus(1)"
          @blur="searchblur(2)"
        />
        <button class="search_btn" type="primary" @click="searchClick">
          搜索
        </button>
        <span>共{{ total }}个讲师</span>
      </div>
    </div> -->
    <!-- screen end -->
    <div class="main">
      <div class="main_list">
        <ul class="clearfix">
          <li class="theClass_li" v-for="item in teacherList" :key=" item.id">
            <!-- <a href="/teacher_details?nav=1"> -->
            <!-- <router-link
              :to="{
                path: 'teacher_details',
                query: { teacherId: item.Id, nav: 1 }
              }"
            >
            </router-link> -->
            <dl>
              <dt>
                <img :src="item.cover" />
              </dt>
              <dd>
                <h2>{{ item.name }}</h2>
                <p class="p2" v-if="item.degrees">
                  {{ item.degrees }}
                </p>
              </dd>
            </dl>
            <!-- </a> -->
          </li>
        </ul>
      </div>
      <!-- main_list end -->
      <div class="block">
        <el-pagination
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
          :current-page.sync="currentPage"
          :page-size="teacherNumber"
          :total="total"
          background
          layout="total,prev, pager, next, jumper,->"
        >
        </el-pagination>
      </div>
      <!-- block end -->
    </div>
    <!-- main end -->
  </div>
</template>

<script>
import Header from "../../components/header/Header.vue"; //公共头部

import banner from "../../page2/banner/banner.vue"; //头部banner图
import { testopiaTeacherList } from "@/api/common";
export default {
  components: {
    // 将组件隐射为标签,登录弹窗
    Header,

    banner
  },
  metaInfo() {
    return {
      title: "启德考培教师团队",
      meta: [
        {
          name: "keywords",
          content: "启德考培教师,雅思教师,托福教师,"
        },
        {
          name: "description",
          content:
            "启德考培在线,启德考培旗下官方网校.启德考培教师团队,讲授托福在线课程、雅思在线课程等出国考试在线课程."
        }
      ]
    };
  },
  data() {
    return {
      screenup: false,
      pageTypeId: 17, //教师banner
      total: 0, //总条数
      tokenkey: "", //key
      currentPage: 1, //页数
      teacherNumber: 15, //列表个数
      CourseClass: 0, //课程分类
      CourseC1: false, //初始隐藏科目
      Subjects: 0, //科目分类
      fxList: [], //分校列表
      BranchSchoolId: 0,
      teacherList: [],
      cityNumber: 0, //分校class
      cityIdList: [], //分校Id
      enumList: [], //枚举列表
      kcflNumber: 0, //课程分类class
      kmList: [], //科目列表
      kmNum: 0, //科目CLASS
      kmIdList: "", //科目Id
      searchValue: "" //搜索至
    };
  },
  created() {
    let that = this;
    that.tokenkey = that.$cookies.get("token");
    //获取枚举列表
    let enumBox = sessionStorage.getItem("enum");
    that.enumList = JSON.parse(enumBox)[0].List;
    // // console.log(that.enumList)
    let kmNumbers = [];
    that.enumList[0].List.filter(item => {
      if (item.Type === 2) {
        kmNumbers.push(item.Name);
      }
    });
    //that.kmList = kmNumbers
    //默认列表
    this.ajaxFuncTeacher(
      that.currentPage,
      that.teacherNumber,
      that.CourseClass,
      that.Subjects,
      that.BranchSchoolId,
      that.searchValue
    );

    //分校列表
    this.$http
      .get("https://schoolapi.eiceducation.com.cn/api/BranchSchool")
      .then(function(response) {
        if (response.data.code == 200) {
          that.fxList = response.data.results;
          var fxId = []; //分校Id
          that.fxList.filter(item => {
            fxId.push(item.Id);
          });
          // // console.log(fxId)
          that.cityIdList = fxId;
        }
      })
      .catch(function() {
        // console.log('数据错误');
      });
  },
  methods: {
    iconShrink() {
      this.screenup = true;
    },
    iconOpen() {
      this.screenup = false;
    },
    handleSizeChange(val) {
      // console.log(`每页 ${val} 条`);
    },
    handleCurrentChange(val) {
      // console.log(`当前页: ${val}`);
      this.currentPage = val;
      this.ajaxFuncTeacher(
        this.currentPage,
        this.teacherNumber,
        this.CourseClass,
        this.Subjects,
        this.BranchSchoolId,
        this.searchValue
      );
    },
    async ajaxFuncTeacher(
      Page,
      Numbers,
      CourseClass,
      Subjects,
      BranchSchoolId,
      keyword
    ) {
      const params = {
        page: Page,
        page_size: Numbers
      };
      if (keyword) {
        params.keyword = keyword;
      }
      try {
        const response = await testopiaTeacherList(params);
        const pageData = (response && response.data && response.data.data) || {};
        this.teacherList = pageData.items || [];
        this.total = pageData.total
      } catch (error) {
        this.teacherList = [];
        this.total = 0;
      }
    },
    //课程分类
    kcflFun(index) {
      let that = this;
      that.kcflNumber = index;
      that.kmNum = 0;
      that.Subjects = 0;
      this.currentPage = 1;
      if (index == 0) {
        that.CourseC1 = false;
        that.CourseClass = 0; //默认为0不限
        this.ajaxFuncTeacher(
          this.currentPage,
          this.teacherNumber,
          this.CourseClass,
          this.Subjects,
          this.BranchSchoolId,
          this.searchValue
        );
        that.kmList = [];
      } else {
        that.CourseC1 = true;
        let indexs = index - 1;
        that.CourseClass = that.enumList[indexs].Id;
        //默认科目不限
        // that.kmNum =0
        // if(that.kmNum ==0){
        //   this.Subjects = 0
        // }
        this.ajaxFuncTeacher(
          this.currentPage,
          this.teacherNumber,
          this.CourseClass,
          this.Subjects,
          this.BranchSchoolId,
          this.searchValue
        );
        //点击课程分类，给科目分类列表赋值
        var kmNumbers = [];
        let kmId = [];
        that.enumList[indexs].List.filter(item => {
          if (item.Type === 2) {
            kmNumbers.push(item.Name);
            kmId.push(item.Id);
          }
        });
        that.kmList = kmNumbers; //科目列表赋值
        that.kmIdList = kmId; //科目Id列表赋值
      }
    },
    //科目
    subjectsFun(index) {
      let that = this;
      that.kmNum = index;
      this.currentPage = 1;
      if (index == 0) {
        that.Subjects = 0; //默认为0不限
        this.ajaxFuncTeacher(
          this.currentPage,
          this.teacherNumber,
          this.CourseClass,
          this.Subjects,
          this.BranchSchoolId,
          this.searchValue
        );
      } else {
        let indexs = index - 1;
        that.Subjects = that.kmIdList[indexs];
        this.ajaxFuncTeacher(
          this.currentPage,
          this.teacherNumber,
          this.CourseClass,
          this.Subjects,
          this.BranchSchoolId,
          this.searchValue
        );
      }
    },
    //分校
    fxFunction(index) {
      let that = this;
      that.cityNumber = index;
      this.currentPage = 1;
      if (index == 0) {
        that.BranchSchoolId = 0; //默认为0不限
        this.ajaxFuncTeacher(
          this.currentPage,
          this.teacherNumber,
          this.CourseClass,
          this.Subjects,
          this.BranchSchoolId,
          this.searchValue
        );
      } else {
        let indexs = index - 1;
        that.BranchSchoolId = that.cityIdList[indexs];
        this.ajaxFuncTeacher(
          this.currentPage,
          this.teacherNumber,
          this.CourseClass,
          this.Subjects,
          this.BranchSchoolId,
          this.searchValue
        );
      }
    },

    // 搜索
    searchClick() {
      this.ajaxFuncTeacher(
        this.currentPage,
        this.teacherNumber,
        this.CourseClass,
        this.Subjects,
        this.BranchSchoolId,
        this.searchValue
      );
    },
    searchfocus(e) {
      this.enter = e;
    },
    searchblur(e) {
      this.enter = e;
    },
    searchEnter() {
      document.onkeydown = e => {
        //13表示回车键，baseURI是当前页面的地址，为了更严谨，也可以加别的，可以打印e看一下
        if (e.keyCode === 13 && this.enter == 1) {
          //回车后执行搜索方法
          this.searchClick();
        }
      };
    },
    teacherDetails(index) {
      let that = this;
      var teacherId = that.teacherList[index].Id;
      sessionStorage.setItem("teacherIdBox", teacherId);

      // this.$router.push({
      //   params: {
      //     Id: teacherId,
      //     // nav:3
      //   }
      // })
    }
  }
};
</script>
<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.bottombox {
  box-shadow: 0px 3px 5px 0px rgba(233, 233, 233, 0.5);
  position: relative;
  z-index: 9;
}

.header_left {
  background: #f00;
}

.banner {
  width: 100%;
  height: 452px;
  position: relative;
  overflow: hidden;
}

.banner img {
  width: 1920px;
  height: 452px;
  position: absolute;
  top: 0;
  left: 50%;
  margin-left: -960px;
}

.screen {
  background: #fff;
}

.screen_1 {
  width: 1180px;
  height: 66px;
  border-bottom: 1px #d5d5d5 solid;
  padding-top: 32px;
  box-sizing: border-box;
  margin: 0 auto;
  margin-bottom: 20px;
}

.screen_1 strong {
  display: block;
  font-size: 16px;
  color: #d5d5d5;
  line-height: 20px;
  float: left;
  font-weight: normal;
}

.screen_1 span {
  display: block;
  font-size: 14px;
  color: #666666;
  line-height: 20px;
  float: right;
  padding-right: 14px;
  background: url(../../assets/publicClass/icon_shrink.png) right no-repeat;
  cursor: pointer;
}

.screen_1 .icon_open {
  background: url(../../assets/publicClass/icon_open.png) right no-repeat;
}

.screen_2 {
  width: 1180px;
  margin: 0 auto;
  box-sizing: border-box;
  border-bottom: 1px #d5d5d5 solid;
  margin-bottom: 20px;
}

.screen_2.up {
  display: none;
}

.screen_2 p {
  margin-bottom: 15px;
  text-align: left;
  display: table;
}

.screen_2 p strong {
  display: inline-block;
  font-size: 14px;
  line-height: 36px;
  color: #999;
  margin-right: 24px;
  float: left;
}

.screen_2 p span {
  display: inline-block;
  width: 1080px;
  float: left;
}

.screen_2 p a {
  display: inline-block;
  min-width: 82px;
  height: 36px;
  font-size: 14px;
  line-height: 36px;
  border-radius: 18px;
  margin-right: 10px;
  color: #333333;
  text-align: center;
  cursor: pointer;
  padding: 0 20px;
  box-sizing: border-box;
  transition: all 0.25s ease-in;
  -moz-transition: all 0.25s ease-in;
  -webkit-transition: all 0.25s ease-in;
}

.screen_2 p a:hover {
  color: #4e5cf6;
}

.screen_2 p a.side {
  background: #f8f8f8;
  color: #4e5cf6;
}

.screen_3 {
  width: 1180px;
  padding-bottom: 20px;
  margin: 0 auto;
  box-sizing: border-box;
  text-align: left;
}

.screen_3 span {
  float: right;
  font-size: 14px;
  color: #333;
  line-height: 36px;
}

.main {
  width: 100%;
  background: #fafafa;
  padding-top: 40px;
  padding-bottom: 78px;
}

.main_list {
  width: 1200px;
  margin: 0 auto;
}

.main_list ul {
  padding-bottom: 60px;
}

.main_list ul li {
  width: 224px;
  float: left;
  background: #ffffff;
  box-shadow: 0px 0px 10px 6px rgba(245, 246, 246, 0.2);
  border-radius: 8px;
  overflow: hidden;
  margin-right: 20px;
  margin-bottom: 20px;
  transition: all 0.25s ease-in;
  -moz-transition: all 0.25s ease-in;
  -webkit-transition: all 0.25s ease-in;
  position: relative;
}

.main_list ul li:nth-child(5n) {
  margin-right: 0;
}

.main_list ul li dt {
  width: 100%;
  height: 200px;
  position: relative;
  background: linear-gradient( 270deg, rgba(216,216,216,0.5) 0%, rgba(216,216,216,0) 100%);
  border-radius: 0px 0px 0px 0px;
  padding-top: 24px;
}
.main_list ul li dt img {
  display: block;
  width: auto;
  height: 200px;
  margin: 0 auto;
}
.main_list ul li dd {
  width: 190px;
  height: 100px;
  background: #FFF;
  margin: 0 auto;
  padding-top: 20px;
}

.main_list ul li dd h2 {
  font-weight: 500;
  font-size: 22px;
  color: #333333;
  line-height: 26px;
  margin-bottom: 5px;
}

.main_list ul li dd p {
  font-size: 14px;
  color: #666666;
  line-height: 24px;
  text-align: left;
}

.block {
  width: 1180px;
  margin: 0 auto;
  text-align: right;
}

.screen_S {
  width: 1180px;
  margin: 0 auto;
  position: relative;
  padding-bottom: 40px;
  margin-top: 40px;
}

.screen_S input {
  width: 250px;
  height: 36px;
  background: #ffffff;
  border-radius: 21px;
  border: 1px solid #dddddd;
  padding: 0 15px;
}

.screen_S .search_btn {
  position: absolute;
  top: 1px;
  left: 245px;
  cursor: pointer;
  width: 36px;
  height: 36px;
  border: none;
  background: url(../../assets/personal/icon_search_Default.png) no-repeat;
  overflow: hidden;
  text-indent: -999px;
}

.screen_S span {
  float: right;
  font-size: 14px;
  color: #333;
  line-height: 36px;
}
</style>



// WEBPACK FOOTER //
// src/page2/teacherList/teacher_list.vue